import React from 'react';
import { helpers } from '@simplybenefits/sb-utils';
import { Chip } from '@mui/material';
import { Text, Theme, i18n, tokens, localizationMaps } from '@simplybenefits/sb-ui-library';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import CoverageBlock from '../../components/CoverageBlock.js';
import CoverageBlockFull from '../../components/CoverageBlockFull.js';

/**
 *
 * @param {*} props
 */
export default function Vision({ classes, expanded, vision, handleChange, showDependentWarning, waivedEHC }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('vision')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('vision') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles.vision) }</Text>
                    {
                        waivedEHC &&
                            <Chip
                                size="small"
                                label="Waived"
                                color="primary"
                                variant="outlined"
                                style={{
                                    margin: "0 10px",
                                    borderRadius: 30,
                                    borderWidth: 2,
                                    borderColor: Theme.colors.lightGrey,
                                    fontFamily: Theme.fonts.type.heading,
                                    fontSize: 14,
                                    color: '#666'
                                }}
                            />
                    }
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        vision.isEligible !== 1 ?
                            <div style={classes.row}> 
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.ineligibleForBenefit) }
                                </Text>
                            </div>
                            : 
                            null
                    }

                    {
                        showDependentWarning ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.waivedBenefitForDependents) }
                                </Text>
                            </div>
                            :
                            null
                    }

                    {
                        vision.isCombinedMaximum ?
                            <>
                                <div style={classes.row}>
                                    <Text small bold margin="10px 0px 10px 0px">
                                        { i18n.t(tokens.labels.coverage.combinedVisionText, { eyeExamReimbursement: helpers.formatNumber(vision.eyeExamReimbursement, 2), combinedAdultMax: helpers.formatNumber(vision.combinedAdultMax, 2, true), combinedChildMax: helpers.formatNumber(vision.combinedChildMax, 2, true) }) }
                                    </Text>
                                </div>

                                <div style={classes.row}>
                                    <Text small bold >
                                        { i18n.t(tokens.labels.coverage.benefit) }
                                    </Text>
                                </div>

                                <div>
                                    <Text small margin="5px 0px 10px 0px">
                                        { i18n.t(tokens.labels.coverage.eyeExam) }
                                    </Text>
                                    <Text small margin="5px 0px 10px 0px">
                                        { i18n.t(tokens.labels.coverage.eyeGlassesContacts) }
                                    </Text>
                                    <Text small margin="5px 0px 0px 0px">
                                        { i18n.t(tokens.labels.coverage.requiredSafetyEyewear) }
                                    </Text>
                                </div>
                            </>
                            :
                            <>
                                <div style={classes.row}>
                                    <Text small bold margin="10px 0px 10px 0px">
                                        {
                                            vision.eyeExamReimbursement ? i18n.t(tokens.labels.coverage.eyeExamReimbursement, { eyeExamReimbursement: vision.eyeExamReimbursement }) : null
                                        }
                                        {" "}
                                        {
                                            vision.eyeGlassesAndContactsReimbursement ? i18n.t(tokens.labels.coverage.eyeGlassesAndEyeWearReimbursement, { eyeGlassesAndContactsReimbursement: vision.eyeGlassesAndContactsReimbursement }) : null
                                        }
                                        {" "}
                                        {
                                            vision.requiredSafetyEyeWearReimbursement ? i18n.t(tokens.labels.coverage.safetyEyeWearReimbursement, { requiredSafetyEyeWearReimbursement: vision.requiredSafetyEyeWearReimbursement }) : null
                                        }
                                    </Text>
                                </div>

                                {
                                    // Temporary
                                    (vision.eyeExamAdultMax === 0 &&
                                    vision.eyeExamChildMax === 0 &&
                                    vision.eyeExamReimbursement === 0 &&
                                    vision.eyeExamRolloverPeriodAdult === 0 &&
                                    vision.eyeExamRolloverPeriodChild === 0 &&
                                    vision.eyeGlassesAndContactsAdultMax === 0 &&
                                    vision.eyeGlassesAndContactsChildMax === 0) ? 
                                        null
                                        : 
                                        <div style={{ marginTop: 10 }}>
                                            <CoverageBlock
                                                title={ i18n.t(tokens.labels.coverage.benefit) }
                                                value={ i18n.t(tokens.labels.maximum) }
                                                type="header"
                                            />
                                            <CoverageBlockFull
                                                coverage={vision}
                                            />
                                        </div>
                                }
                            </>
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    );
}